export default __webpack_public_path__ + "static/HammockNatureMobile-8d24a8f8965e89901a73ad03b59ad8f0.png";